// src/hooks/useSubscription.js
// ✅ Legge i dati già caricati da AuthContext — zero fetch duplicati
import { useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { subscriptionApi } from '../api/subscriptionApi';
import toast from 'react-hot-toast';

export const useSubscription = () => {
  const {
    subscription,
    planLimits,
    loading,
    isPro,
    isEnterprise,
    isFree,
    isSuperAdmin,
    effectivePlan,
    refreshOrganization,
  } = useAuth();

  const [invoices, setInvoices] = useState([]);
  const [payments, setPayments] = useState([]);
  const [invoicesLoaded, setInvoicesLoaded] = useState(false);

  // Carica fatture solo quando necessario (tab billing)
  const loadInvoices = useCallback(async () => {
    if (invoicesLoaded) return;
    try {
      const [invRes, payRes] = await Promise.all([
        subscriptionApi.getInvoices(),
        subscriptionApi.getPaymentHistory()
      ]);
      setInvoices(invRes.data || []);
      setPayments(payRes.data || []);
      setInvoicesLoaded(true);
    } catch (err) {
      console.error('Errore caricamento fatture:', err);
    }
  }, [invoicesLoaded]);

  const upgradeToPro = async (plan = 'PRO') => {
    try {
      const response = await subscriptionApi.upgradeToPro({ plan });
      if (response.data?.paymentUrl) {
        window.location.href = response.data.paymentUrl;
        return { success: true, redirect: true };
      }
      await refreshOrganization();
      toast.success(`Upgrade a ${plan} completato!`);
      return { success: true, data: response.data };
    } catch (err) {
      const message = err.response?.data?.message || 'Errore durante l\'upgrade';
      toast.error(message);
      return { success: false, error: message };
    }
  };

  const cancelSubscription = async () => {
    try {
      const response = await subscriptionApi.cancel();
      await refreshOrganization();
      toast.success('Sottoscrizione cancellata');
      return { success: true, data: response.data };
    } catch (err) {
      const message = err.response?.data?.message || 'Errore durante la cancellazione';
      toast.error(message);
      return { success: false, error: message };
    }
  };

  const plan = effectivePlan || subscription?.plan || 'FREE';
  const isTrialing = subscription?.status === 'TRIALING';
  const trialDaysLeft = subscription?.trialEndsAt
    ? Math.max(0, Math.ceil((new Date(subscription.trialEndsAt) - new Date()) / (1000 * 60 * 60 * 24)))
    : 0;

  return {
    subscription,
    planLimits,
    invoices,
    payments,
    loading,
    error: null,
    upgradeToPro,
    cancelSubscription,
    loadInvoices,
    refresh: refreshOrganization,
    isPro,
    isEnterprise,
    isFree,
    isSuperAdmin,
    isTrialing,
    trialDaysLeft,
    plan,
  };
};